/**
 * Shared 4-tier stock scarcity (PDP, collection cards, Quick Shop).
 * Tiers: in_stock (10+) / low (4–9) / very_low (1–3) / soldout / soon
 */
(function (root) {
  'use strict';

  var TIER_CLASSES = [
    'stock-scarcity--in-stock',
    'stock-scarcity--in_stock',
    'stock-scarcity--low',
    'stock-scarcity--very-low',
    'stock-scarcity--very_low',
    'stock-scarcity--soldout',
    'stock-scarcity--notify-focus',
    'stock-scarcity--soon',
    'pdp-buy-box__stock--soon',
    'pdp-buy-box__stock--soldout',
    'pdp-buy-box__stock--low',
    'quick-shop__stock--soon',
    'quick-shop__stock--soldout',
    'quick-shop__stock--low',
    'quick-shop__stock--very-low'
  ];

  function config() {
    var t = (root.theme && theme.stockTiers) || {};
    return {
      veryLowMax: Number(t.veryLowMax) > 0 ? Number(t.veryLowMax) : 3,
      inStockMin: Number(t.inStockMin) > 1 ? Number(t.inStockMin) : 10,
      enabled: t.enabled !== false
    };
  }

  function inventory(variant) {
    if (!variant) return NaN;
    var invEl = variant.id ? document.getElementById('pvr-' + variant.id) : null;
    if (invEl) {
      var fromEl = parseInt(invEl.getAttribute('data-inventory') || invEl.textContent, 10);
      if (!isNaN(fromEl)) return fromEl;
    }
    if (variant.inventory_quantity != null && variant.inventory_quantity !== '') {
      return parseInt(variant.inventory_quantity, 10);
    }
    return NaN;
  }

  function isManaged(variant) {
    if (!variant) return false;
    if (variant.inventory_management === 'shopify') return true;
    var invEl = variant.id ? document.getElementById('pvr-' + variant.id) : null;
    return !!(invEl && invEl.getAttribute('data-inventory-management') === 'shopify');
  }

  function copyFor(surface, tier, qty) {
    var short = surface === 'card' || surface === 'quick_shop';
    if (tier === 'soon') return 'Launching Soon';
    if (tier === 'soldout') return surface === 'card' ? 'Notify Me' : 'Sold Out';
    if (tier === 'very_low') {
      return short
        ? '👀 Only ' + qty + ' left!'
        : '👀 Only ' + qty + ' left in stock — hurry!';
    }
    if (tier === 'low') {
      return short
        ? '🔥 Only ' + qty + ' left — hurry!'
        : '🔥 Only ' + qty + ' left in stock — hurry!';
    }
    return short ? 'In stock' : 'In stock — ready to ship';
  }

  function resolve(variant, opts) {
    opts = opts || {};
    var surface = opts.surface || 'pdp';
    if (opts.comingSoon) {
      return { tier: 'soon', qty: 0, copy: copyFor(surface, 'soon'), className: 'stock-scarcity--soon' };
    }
    if (!variant || !variant.available) {
      return { tier: 'soldout', qty: 0, copy: copyFor(surface, 'soldout'), className: 'stock-scarcity--soldout' };
    }
    var cfg = config();
    var qty = inventory(variant);
    var managed = isManaged(variant);
    if (cfg.enabled && managed && qty > 0 && qty <= cfg.veryLowMax) {
      return { tier: 'very_low', qty: qty, copy: copyFor(surface, 'very_low', qty), className: 'stock-scarcity--very-low' };
    }
    if (cfg.enabled && managed && qty > 0 && qty < cfg.inStockMin) {
      return { tier: 'low', qty: qty, copy: copyFor(surface, 'low', qty), className: 'stock-scarcity--low' };
    }
    return { tier: 'in_stock', qty: qty, copy: copyFor(surface, 'in_stock', qty), className: 'stock-scarcity--in-stock' };
  }

  function clearNotify(el) {
    if (!el) return;
    el.classList.remove('stock-scarcity--notify-focus');
    el.removeAttribute('data-launch-notify');
    el.removeAttribute('data-launch-mode');
    el.removeAttribute('data-launch-handle');
    el.removeAttribute('data-launch-title');
    el.removeAttribute('data-launch-url');
    el.removeAttribute('data-launch-variant');
    el.removeAttribute('data-launch-length');
    if (el.getAttribute('role') === 'button') el.removeAttribute('role');
    if (el.getAttribute('tabindex') === '0') el.removeAttribute('tabindex');
  }

  function applyNotifyFocus(el, opts) {
    if (!el) return;
    opts = opts || {};
    var length = opts.length || '';
    var copy = length
      ? 'Notify me when ' + length + ' is back'
      : 'Notify me when this length is back';
    TIER_CLASSES.forEach(function (cls) { el.classList.remove(cls); });
    el.classList.add('stock-scarcity');
    el.classList.add('stock-scarcity--soldout');
    el.classList.add('stock-scarcity--notify-focus');
    el.hidden = false;
    var textEl = el.querySelector('[data-stock-scarcity-text], [data-pdp-stock-text], [data-quick-shop-stock-text]');
    if (textEl) textEl.textContent = copy;
    else el.textContent = copy;

    el.setAttribute('data-launch-notify', '');
    el.setAttribute('data-launch-mode', opts.mode || 'restock');
    if (opts.handle) el.setAttribute('data-launch-handle', opts.handle);
    if (opts.title) el.setAttribute('data-launch-title', opts.title);
    if (opts.url) el.setAttribute('data-launch-url', opts.url);
    if (opts.variantIds) el.setAttribute('data-launch-variant', opts.variantIds);
    if (length) el.setAttribute('data-launch-length', length);
    el.setAttribute('role', 'button');
    el.setAttribute('tabindex', '0');
  }

  function apply(el, result, opts) {
    if (!el || !result) return;
    opts = opts || {};
    TIER_CLASSES.forEach(function (cls) { el.classList.remove(cls); });
    el.classList.add('stock-scarcity');
    el.classList.add(result.className);
    el.hidden = false;
    var textEl = el.querySelector('[data-stock-scarcity-text], [data-pdp-stock-text], [data-quick-shop-stock-text]');
    if (textEl) textEl.textContent = result.copy;
    else el.textContent = result.copy;

    var surface = opts.surface || '';
    if (!surface) {
      if (el.classList.contains('stock-scarcity--card')) surface = 'card';
      else if (el.classList.contains('stock-scarcity--quick_shop')) surface = 'quick_shop';
      else if (el.classList.contains('stock-scarcity--pdp')) surface = 'pdp';
    }

    if (surface === 'card' && result.tier === 'soldout' && opts.notify) {
      el.setAttribute('data-launch-notify', '');
      el.setAttribute('data-launch-mode', opts.notify.mode || 'restock');
      if (opts.notify.handle) el.setAttribute('data-launch-handle', opts.notify.handle);
      if (opts.notify.title) el.setAttribute('data-launch-title', opts.notify.title);
      if (opts.notify.url) el.setAttribute('data-launch-url', opts.notify.url);
    } else {
      clearNotify(el);
    }
  }

  root.SHHStock = {
    resolve: resolve,
    apply: apply,
    applyNotifyFocus: applyNotifyFocus,
    copyFor: copyFor
  };
})(window);
